import { render, staticRenderFns } from "./SuggestionInput.vue?vue&type=template&id=26312b24&scoped=true&"
import script from "./SuggestionInput.vue?vue&type=script&lang=js&"
export * from "./SuggestionInput.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionInput.vue?vue&type=style&index=0&id=26312b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26312b24",
  null
  
)

export default component.exports